export default __webpack_public_path__ + "static/media/Sketch.2f4878ae.svg";